import { ButtonProps as MuiButtonProps, styled } from "@mui/material";

import { colors } from "@/Utils";

import { Button as MuiButton } from "@mui/material";

export const StyledApprovalButton = styled(MuiButton)({
  backgroundColor: colors.greenSuccess,
  color: colors.white,
  borderRadius: "6.25rem",
  textTransform: "none",
  padding: "0.25rem 1.25rem",
  width: "fit-content",

  "&:hover": {
    backgroundColor: "rgba(0, 169, 83, 0.8)",
  },

  "&:disabled": {
    backgroundColor: "rgba(0, 169, 83, 0.4)",
    color: colors.white,
    cursor: "not-allowed",
  },
});

interface ApprovalButtonProps extends Omit<MuiButtonProps, "variant"> {
  children: React.ReactNode;
}

export const ApprovalButton: React.FC<ApprovalButtonProps> = ({ children, ...props }) => {
  return <StyledApprovalButton {...props}>{children}</StyledApprovalButton>;
};
